var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isActiveVerticalAlert)?_c('div',{staticClass:"caution-pop"},[_c('img',{attrs:{"src":"images/common-function/caution.svg","alt":"画面が横長になっているか確認してね。"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }